window.vf.enterpriseIEBanner = (function () {
    'use strict';

    const IE_NOTICE_BANNER_HTML = '<div id="ie-notice-banner" class="mod mod-ep-notice-banner ie-version">'
        + '<div class="mod-ep-notice-banner__content">'
           + '<div class="mod-ep-notice-banner__icon">'
              + '<svg class="i-sml">'
                + '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/simplicity/enterprise-svgdefs.svg#i-block-sml"></use>'
              + '</svg>'
            + '</div>'
            + '<div class="mod-ep-notice-banner__txt">'
              + '<p><strong>Achtung:</strong> Sie nutzen den Internet Explorer 11. Der wird nicht mehr unterstützt. <a href="https://eweb8.vfd2-testnet.de/business/veralteter-browser.html">Mehr Infos</a></p>'
            + '</div>'
        + '</div>'
    + '</div>';

    var blacklist = [
        '/simplicity/pages/enterprise-only/enterprise-ie-banner/blacklisted.html',
        '/business/business-portale.html',
        '/business/business-portale/*',
        '/ussa/*'
    ];

    function glob(pattern, input) {
        var re = new RegExp(pattern.replace(/([.?+^$[\]\\(){}|\/-])/g, '\\$1').replace(/\*/g, '.*'));
        return re.test(input);
    }

    function isBannerOnBlacklist() {
        var pageSlug = window.location.pathname;

        return blacklist.some(function(site) {
            return glob(site, pageSlug);
        });
    }

    function createNoticeBannerElement() {
        var div = document.createElement('div');
        div.innerHTML = IE_NOTICE_BANNER_HTML.trim();

        return div.firstChild;
    }

    function doesAnotherBannerAlreadyExist() {
        var noticeBannerClass = 'mod-ep-notice-banner';
        return document.getElementsByClassName(noticeBannerClass).length > 0;
    }

    function isUsingIE() {
        return (navigator.userAgent.indexOf('MSIE') !== -1
            || navigator.appVersion.indexOf('Trident/') > -1)
    }

    function redirectToInfoPage() {
        window.location.replace('https://eweb8.vfd2-testnet.de/business/veralteter-browser.html');
    }

    function init() {
        if (!isUsingIE()) {
            return;
        }

        if (isBannerOnBlacklist()) {
            return;
        }

        if(window.location.href === 'https://eweb8.vfd2-testnet.de/business/veralteter-browser.html') {
            return;
        }

        redirectToInfoPage();
    }

    return {
        'init': init
    };

})();

window.vf.enterpriseIEBanner.init();
